import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineStore } from 'pinia';
import SiteSettingsApi from '~/core/api/siteSettings.api';
export default defineStore('siteSettings', function () {
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  var siteSettings = ref();
  function fetch() {
    return _fetch.apply(this, arguments);
  }
  function _fetch() {
    _fetch = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!siteSettings.value) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return SiteSettingsApi.get();
          case 5:
            siteSettings.value = _context.sent.data;
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            $captureException(_context.t0, {
              component: 'useSiteSettingsStore',
              method: 'fetch'
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 8]]);
    }));
    return _fetch.apply(this, arguments);
  }
  var isEsiaConfirmationHidden = computed(function () {
    var _siteSettings$value$h, _siteSettings$value;
    return (_siteSettings$value$h = (_siteSettings$value = siteSettings.value) === null || _siteSettings$value === void 0 ? void 0 : _siteSettings$value.hideEsiaConfirmationButton) !== null && _siteSettings$value$h !== void 0 ? _siteSettings$value$h : false;
  });
  var isAchievementsHidden = computed(function () {
    var _siteSettings$value$h2, _siteSettings$value2;
    return (_siteSettings$value$h2 = (_siteSettings$value2 = siteSettings.value) === null || _siteSettings$value2 === void 0 ? void 0 : _siteSettings$value2.hideAchievements) !== null && _siteSettings$value$h2 !== void 0 ? _siteSettings$value$h2 : false;
  });
  return {
    siteSettings: siteSettings,
    fetch: fetch,
    isEsiaConfirmationHidden: isEsiaConfirmationHidden,
    isAchievementsHidden: isAchievementsHidden
  };
});